import React from 'react';
import { Clock } from 'lucide-react';

const fmt = (iso) => new Date(iso).toLocaleString('es-ES', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' });

export const StaleDataNote = ({ data, testId = 'meta-stale-note' }) => {
  if (!data?.stale || !data?.data_as_of) return null;
  return (
    <div className="flex items-center gap-2 rounded-md border border-amber-200 bg-amber-50 px-3 py-2 text-xs text-amber-900" data-testid={testId}>
      <Clock className="w-3.5 h-3.5 shrink-0" />
      Meta no ha respondido ahora mismo: se muestran los últimos datos disponibles, del {fmt(data.data_as_of)}.
    </div>
  );
};
